export default __webpack_public_path__ + "static/media/trade2.83d4a466.png";